import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-outletselection',
  templateUrl: './outletselection.component.html',
  styleUrls: ['./outletselection.component.css']
})
export class OutletselectionComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;


  @Input() selectedcompany: string = "";

  @Input() companycoll: any[] = [];

  @Output() emitData = new EventEmitter();

 
  constructor(private appService: DhukanDataService, public loginService: LoginDataService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {
    
  }


  ngOnInit() {
    try {
     
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {
   
  }


  //Save Btn Click
  fnApplyFilter(companyid) {
    try {
      var data = {
       companyid:companyid
      }
      this.emitData.emit(data);
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
